const Styles = {
  cardStyle: {
    marginLeft: 15,
    marginRight: 15,
    marginBottom: 15,
    marginTop: 12,
    height: "calc(100% - 80px)",
    overflow: "auto",
    position: "relative",
  },
  filters: {
    position: "relative",
    marginBottom: "2rem",
  },
  pagination: {
    display: "flex",
    justifyContent: "center",
    margin: "20px 0",
  },
  search: {
    display: "flex",
    justifyContent: "space-between",
    gap: "20px",
  },
  searchInput: {
    width: "40%",
    borderRadius: "0.5rem",
  },
  cell: {
    textAlign: "center",
    color: "#183053",
  },
  icon: {
    cursor: "pointer",
    marginRight: "16px",
    fontSize: "10px",
  },
  applyButton: {
    width: "154px",
    height: "40px",
  },
  label: {
    flex: 1,
    color: "#8C8C8C",
    fontSize: "16px",
    width: "30%",
  },
  inputContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    width: "100%",
  },
  action: {
    width: "100%",
  },
  emptyContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 400,
  },
  noDataMsg: {
    color: "#515772",
  },
  ActionBtnContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  tableHeadCells: {
    // padding: "8px",
    color: "#000000",
    fontWeight: 600,
    background: "#BAD9EC",
  },
};
export default Styles;
